export default function Git_What_is_SSH() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git What is SSH?</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/github/ssh</p>
    </div>
  );
}
